import { encodeFunctionData, zeroAddress } from 'viem';
import { ValidateOrderError } from '../errors/base.js';
import { fetchJSON } from '../internal/api.js';
import { isContractCall } from '../types/order.js';
import { getApiUrl } from '../utils/getApiUrl.js';
import { toJSON } from '../utils/toJSON.js';
// validateOrder calls /check - checking if an order is valid
export async function validateOrder(params) {
    const { environment, ...order } = params;
    const apiUrl = getApiUrl(environment);
    const json = await fetchJSON(`${apiUrl}/check`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: serialize(order),
    });
    if (!isValidateRes(json)) {
        throw new Error(`Unexpected validation response: ${JSON.stringify(json)}`);
    }
    return json;
}
const serialize = (order) => {
    try {
        const calls = order.calls.map((call) => {
            if (!isContractCall(call)) {
                return {
                    target: call.target,
                    value: call.value,
                    data: '0x',
                };
            }
            const callData = encodeFunctionData({
                abi: call.abi,
                functionName: call.functionName,
                args: call.args,
            });
            return {
                target: call.target,
                value: call.value,
                data: callData,
            };
        });
        return toJSON({
            orderId: order.owner ?? zeroAddress,
            sourceChainId: order.srcChainId,
            destChainId: order.destChainId,
            fillDeadline: order.fillDeadline ?? Math.floor(Date.now() / 1000 + 86400),
            calls,
            deposit: {
                amount: order.deposit.amount,
                token: order.deposit.token ?? zeroAddress,
            },
            expenses: [
                {
                    amount: order.expense.amount,
                    token: order.expense.token ?? zeroAddress,
                    spender: order.expense.spender ?? zeroAddress,
                },
            ],
        });
    }
    catch (e) {
        const error = e instanceof Error
            ? e
            : new Error(e.message ?? 'Invalid order');
        throw error;
    }
};
// asserts a json response is ValidationResponse
const isValidateRes = (json) => {
    // TODO schema validation
    const res = json;
    return (json != null &&
        (res.accepted != null ||
            (res.rejected != null &&
                res.rejectReason != null &&
                res.rejectDescription != null) ||
            res.error != null));
};
export function assertAcceptedResult(res) {
    if (!res.accepted) {
        if (res.error != null) {
            throw new ValidateOrderError(res.error.message, `Code ${res.error.code}`);
        }
        if (res.rejected) {
            throw new ValidateOrderError(res.rejectDescription ?? 'Server rejected order', res.rejectReason);
        }
    }
}
//# sourceMappingURL=validateOrder.js.map